import React from 'react'

const PaginationRightArrow = () => (
  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.504 8.664l-6.395 4.263A2 2 0 010 11.263V2.737a2 2 0 013.11-1.664l6.394 4.263a2 2 0 010 3.328z"
      fill="#41AADA"
      fillRule="evenodd"
    />
  </svg>
)

export default PaginationRightArrow
